import { ActiveTabs } from './Tab.enums';

export const TABS = Object.values(ActiveTabs);
